var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"bars"}},[_c('svg',{attrs:{"width":"100%","height":"400"}})])}
var staticRenderFns = []

export { render, staticRenderFns }